const values = [
  {
    icon: "ri-heart-2-line",
    title: "Trato cercano y humano",
    description:
      "No somos un comparador automático. Detrás de cada consulta hay una persona que te escucha, analiza tu situación real y te explica todo con claridad.",
    accent: "teal",
  },
  {
    icon: "ri-eye-line",
    title: "Claridad y transparencia",
    description:
      "Te explicamos exactamente qué estás pagando, por qué y cómo puedes mejorarlo. Sin tecnicismos, sin letra pequeña, sin sorpresas.",
    accent: "yellow",
  },
  {
    icon: "ri-line-chart-line",
    title: "Optimización real de costes",
    description:
      "Identificamos oportunidades concretas de ahorro en tu contrato, potencia, tarifa y consumo. Ahorro medible desde el primer mes.",
    accent: "teal",
  },
  {
    icon: "ri-compass-3-line",
    title: "Acompañamiento continuo",
    description:
      "No te dejamos solo tras el primer estudio. Estamos contigo en cada cambio del mercado, revisión de factura y decisión energética.",
    accent: "yellow",
  },
];

export default function ValueProposition() {
  return (
    <section className="py-24 bg-faro-gray">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-faro-teal text-sm font-semibold uppercase tracking-widest">
            Por qué elegirnos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-faro-navy mt-3 mb-4">
            Una forma diferente de asesorar
          </h2>
          <p className="text-faro-gray-text text-lg max-w-2xl mx-auto">
            En Faro Energía no buscamos solo vender. Buscamos que entiendas tu energía y tomes mejores decisiones con criterio propio.
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-xl p-8 border border-faro-gray-mid hover:border-faro-teal/30 transition-all duration-300 group"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl mb-5 ${
                  item.accent === "teal"
                    ? "bg-faro-teal-pale text-faro-teal"
                    : "bg-faro-yellow-pale text-faro-yellow"
                }`}
              >
                <i className={`${item.icon} text-xl`} />
              </div>
              <h3 className="text-faro-navy font-semibold text-lg mb-3">
                {item.title}
              </h3>
              <p className="text-faro-gray-text text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
